import React, { useContext } from 'react'

import { AppState } from '../../types'
import { ThemeContext } from '../../contexts'
import { useSelector } from 'react-redux'
import ThemedButton from '../ThemedButton'
import { HeaderProps } from '../../types'
import CountryCart from '../Cart'
import Search from '../Search/index'
import './style.scss'

const Header = ({ handleSubmit, handleChange, search }: HeaderProps) => {
  const loadingCountries = useSelector(
    (state: AppState) => state.countries.isLoading
  )
  const { theme } = useContext(ThemeContext)

  return (
    <div
      className="header-container"
      style={{ backgroundColor: theme.buttonColor }}
    >
      <div className="header-wrapper">
        {loadingCountries ? (
          <div className="header-search">
            <Search
              handleSubmit={handleSubmit}
              handleChange={handleChange}
              search={search}
            />
            <CountryCart />
            <ThemedButton />
          </div>
        ) : (
          ''
        )}
      </div>
    </div>
  )
}

export default Header
